var map = {
	"./cuhk-20221123.jpg": "6078",
	"./etnet-20210817.jpg": "8339",
	"./etnet-20220811.jpg": "712f",
	"./hk01-20201123.jpg": "c04d",
	"./hk01-20201209.png": "4bbe",
	"./hket-20210602.jpg": "63da",
	"./hkstp-20210105.jpg": "3cd0",
	"./yahoo-20210817.jpg": "1760",
	"./yahoo-20220811.jpg": "9a4f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "afc5";